import type { RouteObject } from "react-router-dom";
import Home from "../pages/home/page";
import NotFound from "../pages/NotFound";
import Dashboard from "../pages/dashboard/page";
import Automaten from "../pages/automaten/page";
import Verkauf from "../pages/verkauf/page";
import Lager from "../pages/lager/page";
import Finanzen from "../pages/finanzen/page";
import Budgetierung from "../pages/finanzen/budgetierung/page";
import Zahlungen from "../pages/zahlungen/page";
import Vertraege from "../pages/vertraege/page";
import Investitionen from "../pages/investitionen/page";
import Kontakte from "../pages/kontakte/page";
import Passwoerter from "../pages/passwoerter/page";
import Dokumente from "../pages/dokumente/page";
import Vorlagen from "../pages/vorlagen/page";
import Kalender from "../pages/kalender/page";
import Projekte from "../pages/projekte/page";
import Referenzen from "../pages/referenzen/page";
import AuthPage from "../pages/auth/page";
import ProtectedRoute from "../components/auth/ProtectedRoute";
import Wartung from '../pages/wartung/page';
import Generator from '../pages/generator/page';
import VertraegeGenerator from '../pages/vertraege-generator/page';
import Finanzplanung from '../pages/finanzplanung/page';

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/auth",
    element: <AuthPage />,
  },
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "/automaten",
    element: (
      <ProtectedRoute>
        <Automaten />
      </ProtectedRoute>
    ),
  },
  {
    path: "/lager",
    element: (
      <ProtectedRoute>
        <Lager />
      </ProtectedRoute>
    ),
  },
  {
    path: "/verkauf",
    element: (
      <ProtectedRoute>
        <Verkauf />
      </ProtectedRoute>
    ),
  },
  {
    path: "/finanzen",
    element: (
      <ProtectedRoute>
        <Finanzen />
      </ProtectedRoute>
    ),
  },
  {
    path: "/finanzen/budgetierung",
    element: (
      <ProtectedRoute>
        <Budgetierung />
      </ProtectedRoute>
    ),
  },
  {
    path: "/zahlungen",
    element: (
      <ProtectedRoute>
        <Zahlungen />
      </ProtectedRoute>
    ),
  },
  {
    path: "/vertraege",
    element: (
      <ProtectedRoute>
        <Vertraege />
      </ProtectedRoute>
    ),
  },
  {
    path: "/investitionen",
    element: (
      <ProtectedRoute>
        <Investitionen />
      </ProtectedRoute>
    ),
  },
  {
    path: "/kontakte",
    element: (
      <ProtectedRoute>
        <Kontakte />
      </ProtectedRoute>
    ),
  },
  {
    path: "/passwoerter",
    element: (
      <ProtectedRoute>
        <Passwoerter />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dokumente",
    element: (
      <ProtectedRoute>
        <Dokumente />
      </ProtectedRoute>
    ),
  },
  {
    path: "/vorlagen",
    element: (
      <ProtectedRoute>
        <Vorlagen />
      </ProtectedRoute>
    ),
  },
  {
    path: "/kalender",
    element: (
      <ProtectedRoute>
        <Kalender />
      </ProtectedRoute>
    ),
  },
  {
    path: "/projekte",
    element: (
      <ProtectedRoute>
        <Projekte />
      </ProtectedRoute>
    ),
  },
  {
    path: "/referenzen",
    element: (
      <ProtectedRoute>
        <Referenzen />
      </ProtectedRoute>
    ),
  },
  {
    path: "/wartung",
    element: (
      <ProtectedRoute>
        <Wartung />
      </ProtectedRoute>
    ),
  },
  {
    path: "/generator",
    element: (
      <ProtectedRoute>
        <Generator />
      </ProtectedRoute>
    ),
  },
  {
    path: "/vertraege-generator",
    element: (
      <ProtectedRoute>
        <VertraegeGenerator />
      </ProtectedRoute>
    ),
  },
  {
    path: "/finanzplanung",
    element: (
      <ProtectedRoute>
        <Finanzplanung />
      </ProtectedRoute>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;